var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7498 1.32391V11.1934L13.1248 8.56833L10.4998 11.1934L10.5 0.693359C2.62514 0.693359 0 3.31839 0 11.1934C0 19.0683 2.62503 21.6934 10.5 21.6934C18.375 21.6934 21 19.0683 21 11.1934C21 5.43177 19.5822 2.49164 15.7498 1.32391Z",
    fill: "#9B9FB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalMessageIcon);
export default __webpack_public_path__ + "static/media/JournalMessageIcon.43f5f2fc4e2dd86a59569b48a0d1791a.svg";
export { ForwardRef as ReactComponent };